import { Injectable } from '@angular/core';
// import { io } from 'socket.io-client';
import * as io from 'socket.io-client';
import { config } from '../helper/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket!: any;

  constructor() {
    // this.initWebSocket();
  };

  public initWebSocket(uId, clientId) {
    console.log(uId, clientId, config.type)
    if (config.type == "app") {
      this.socket = io(config.socketEndPointEc, {
        path: '/socket',
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        transports: ['websocket'],
        query: {
          uId: uId,
          clientId: clientId
        }
      });
      this.socket.on("success", (data: any) => {
        // console.log("message is ", data);
      });
    } else {
      this.socket = new WebSocket('ws://' + window.location.hostname + ':81/'); // Update the WebSocket URL accordingly
    }
  };

  public send(data: any) {
    this.socket.send(JSON.stringify(data));
  };

  public onMessage(callback: (data: any) => void) {
    this.socket.onmessage = (event: any) => {
      console.log(event)
      const obj = JSON.parse(event.data);
      callback(obj);
    };
  }

  updateSensorData(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('sensorData', (data: any) => {
        observer.next(data)
      });
    });
  };

  updateDashBoardData(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('completeData', (data: any) => {
        observer.next(data)
      });
    });
  };

  closeWebSocket(): void {
    this.socket.close();
  };

  getWebSocketStatus(): boolean {
    return this.socket.readyState === WebSocket.OPEN;
  };

  getSocket(): WebSocket {
    return this.socket;
  };
}